export const CHART_COLORS = {
    WEIGHT: 'primary.main',
    REPS: 'secondary.main'
} as const

export const CHART_MARGINS = {
    top: 20,
    right: 20,
    bottom: 30,
    left: 40
} as const

export const CHART_DIMENSIONS = {
    height: 400,
    skeletonHeight: 200
} as const 